import React from "react";

const Logo = (props) => {
  return (
    <img alt="Logo" className="h-16 p-2" src="/static/logo.png" {...props} />
  );
};

export default Logo;
